import { NgModule } from "@angular/core";
import { IonicPageModule } from "ionic-angular";
import { ItemDetailPage } from "./item-detail";
import { ComponentsModule } from "../../components/components.module";
import { PipesModule } from "../../pipes/pipes.module";

@NgModule({
  declarations: [ItemDetailPage],
  imports: [
    IonicPageModule.forChild(ItemDetailPage),
    ComponentsModule,
    PipesModule,
  ],
})
export class ItemDetailPageModule {}



// WEBPACK FOOTER //
// ./src/pages/item-detail/item-detail.module.ts